/* Small, page-independent behavior for the command shell. Dealer owns search. */
(function () {
    'use strict';
    if (window.wyldcardsCommandShell) return;
    window.wyldcardsCommandShell = true;
    // Reordering changes the origin card's number; every view must return to that same card.
    window.wyldcardsStackViewPosition = function (number) {
        document.querySelectorAll('[data-stack-view-link]').forEach(function (link) {
            var url = new URL(link.href, window.location.href);
            url.searchParams.set('from', String(number));
            link.href = url.toString();
        });
        var sortFrom = document.querySelector('.wyldcards-storyboard-sort-form input[name="from"]');
        if (sortFrom) sortFrom.value = String(number);
    };
    function fitKeyboard() {
        var input = document.querySelector('[data-dealer-inline-input]');
        var dialog = document.getElementById('command-palette');
        var viewport = window.visualViewport;
        var editingDealer = document.activeElement === input || (dialog && dialog.open && dialog.contains(document.activeElement));
        var covered = input && viewport && editingDealer
            ? Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop)) : 0;
        document.documentElement.style.setProperty('--wc-command-keyboard-inset', (covered > 80 ? covered : 0) + 'px');
    }
    function init() {
        fitKeyboard();
        var main = document.querySelector('main.command-page, main.command-auth, main.command-landing');
        if (!main) return;
        if (!main.id) main.id = 'main-content';
        document.querySelectorAll('[data-dealer-shortcut]').forEach(function (key) {
            key.textContent = /Mac|iPhone|iPad/.test(navigator.platform) ? '⌘ K' : 'Ctrl K';
        });
        // Keep the active settings section visible in the horizontal phone rail.
        var active = main.querySelector('.account-tabs [aria-current="page"]');
        if (active && window.matchMedia('(max-width: 47.99rem)').matches) {
            active.parentElement.scrollLeft = active.offsetLeft - active.parentElement.offsetLeft;
        }
    }
    document.addEventListener('htmx:afterSettle', init);
    document.addEventListener('htmx:historyRestore', init);
    document.addEventListener('focusin', fitKeyboard);
    document.addEventListener('focusout', function () { window.requestAnimationFrame(fitKeyboard); });
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', fitKeyboard);
        window.visualViewport.addEventListener('scroll', fitKeyboard);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
